import React from 'react';
import classnames from 'classnames';
import { Radio } from './Radio';
import { useForm } from '../Form';
import { Stack } from '../../Stack/Stack';

export interface RadioOption<T> {
  label: string;
  value: T;
  checked?: boolean;
}

interface Props<T> {
  name: string;
  values: RadioOption<T>[];
  layout?: 'row' | 'list';
}

export function RadioGroup<T extends string | number>({ name, values, layout = 'row' }: Props<T>): JSX.Element {
  const [initialValue, setInitialValue] = useForm(name);

  return (
    <Stack className={classnames('radio-group', `radio-group--${layout}`)} line={layout === 'row'} size="lg">
      {values.map((value) => (
        <Radio
          key={value.label}
          label={value.label}
          value={value.value.toString()}
          name={name}
          checked={value.checked || value.value === initialValue}
          onChange={(changeValue) => {
            const isNumeric = typeof value.value === 'number';
            setInitialValue(isNumeric ? parseFloat(changeValue) : changeValue);
          }}
        />
      ))}
    </Stack>
  );
}
